import { ActionTree }                             from 'vuex';
import { RootState }                              from '@/store/store.types';
import { RateCheckerConfiguration, RateCheckerState } from '@/views/rate-checker-configuration/rate-checker/rate-checker.types';
import * as rateCheckerServices from '@/views/rate-checker-configuration/rate-checker/rate-checker.service';
import { Notification } from '@/components/notification/notification';
import i18n from '@/i18n';
import { useGlobals } from '@/hooks/use-globals';

const actions: ActionTree<RateCheckerState, RootState> = {
  async rateCheckerConfiguration({ commit }): Promise<void> {
    try {
      const { data }: {data: RateCheckerConfiguration} = await rateCheckerServices.rateCheckerConfiguration();
      commit('setBrandDataSource', data.brandDataSource);
      commit('setOrderListOfSources', data.sources);
      commit('removeDoubleSources');
    } catch (e) {
      throw new Error(e);
    }
  },
  async checkRateChecker(): Promise<void> {
    const { router } = useGlobals();
    try {
      const { data } = await rateCheckerServices.checkRateChecker();
      if (!data.availability) {
        await router.push('/settings');
      }
    } catch (e) {
      await router.push('/settings');
      throw new Error(e);
    }
  },
  async getDataSource({ commit }): Promise<void> {
    try {
      const { data } = await rateCheckerServices.dataSource();
      commit('setDataSource', data);
      commit('setSources', data);
      commit('removeDoubleSources');
    } catch (e) {
      throw new Error(e);
    }
  },
  async saveRateCheckerConfiguration({ state, rootState }): Promise<void> {
    const payload = {
      brandDataSource: state.brandDataSource,
      sources: state.orderListOfSources,
    };
    try {
      await rateCheckerServices.saveRateCheckerConfiguration(payload);
      Notification.success(
        i18n.t(`${rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vRateChecker.notification.success.updatedConfiguration'),
      );
    } catch (e) {
      const info = e.response.data;
      const msg = `${info[ 0 ].field} ${info[ 0 ].reason}`;
      Notification.error(
        i18n.t(`${rootState.i18n.GLOBAL_PATH}.errors.error`), msg.toLocaleLowerCase().split('_').join(' '),
      );
      throw new Error(e);
    }
  },
};

export default actions;
